<template>
    <flex-element :element-type="elementType" class="f-inline-flex f-self-start">
        <input
            class="f-w-1/1 input"
            :name="inputName"
            :type="inputType"
            :placeholder="placeholder"
            :pattern="pattern ? pattern : false"
            :required="required"
            :value="inputValueNew"
            :aria-label="ariaLabel"
            :aria-labelledby="ariaLabelledBy"
            style="background-color:inherit;"
            @input="onInput"
            @keyup="onKeyup"
            @invalid="onInvalidInput"
        >
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';
import { getCookie } from '@/utils/cookie';

export default {
    name: 'a-input',
    mixins: [baseAtom],

    props: {
        inputName: {
            type: String,
            required: true,
        },

        inputType: {
            type: String,
            required: true,
            default: 'text',
        },

        inputValue: {
            type: String,
            default: '',
        },

        pattern: {
            type: String,
            default: '',
        },

        placeholder: {
            type: String,
            default: '',
        },

        required: {
            type: Boolean,
            default: false,
        },

        validationMessage: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            inputValueNew: '',
        };
    },

    created() {
        this.inputValueNew = this.inputValue; // don't remove, needed for the "set cookie" logic in o-form-container
    },

    beforeMount() {
        if (this.getElementData('load-cookie')) {
            this.inputValueNew = decodeURIComponent(getCookie(this.inputName) || this.inputValue || '');
        }
    },

    methods: {
        onInput(e) {
            e.target.setCustomValidity('');
            this.inputValueNew = e.target.value;
        },

        onKeyup(e) {
            this.$emit('keyup', e);
        },

        onInvalidInput(e) {
            e.target.setCustomValidity(this.validationMessage);
        },
    },
};
</script>

<style lang="scss" scoped>
.input {
    font-size: 1em;
}
</style>
